const pt = {
    path: '/pt',
    name: '🇧🇷 Pt',
    shorthand: 'pt',
}
exports.pt = pt
